import websocketPrintClient from "./websocketPrintClient.js";
import { dispatchSetShowPrinterAlert } from "./alerts";

export const initializePrintService = async (options = {}) => {
  try {
    console.log("Initializing WebSocket Print Service");

    const host = options.host || "localhost";
    const port = options.port || 3020;

    await websocketPrintClient.connect({ host, port });

    console.log(
      `Print Service connected to WebSocket server at ${host}:${port}`
    );

    return true;
  } catch (error) {
    console.error("Failed to initialize Print Service:", error);
    dispatchSetShowPrinterAlert(true);
    return false;
  }
};

const ensureConnection = async () => {
  const isNotConnected = !websocketPrintClient.isConnected;

  if (isNotConnected) {
    console.log("WebSocket Print Client not connected, connecting now...");
    await initializePrintService();
  }
};

export const printOrderTicket = async (orderData) => {
  try {
    console.log("Printing order ticket via WebSocket Print Service");

    await ensureConnection();

    await websocketPrintClient.printOrderTicket(orderData);

    console.log("Print request sent successfully");

    return true;
  } catch (error) {
    console.error("Print Error:", error);
    throw error;
  }
};

export const printShippingRoute = async (shippingRouteData) => {
  try {
    console.log("Printing shipping route via WebSocket Print Service");

    await ensureConnection();

    await websocketPrintClient.printShippingRoute(shippingRouteData);

    console.log("Shipping route print request sent successfully");

    return true;
  } catch (error) {
    console.error("Print Error:", error);
    alert(`Print Error: ${error.message}`);
    dispatchSetShowPrinterAlert(true);

    throw error;
  }
};

export const printHtmlContent = async ({
  content,
  type = "order",
  printOptions = {},
}) => {
  try {
    console.log(
      `Printing HTML content via WebSocket Print Service (type: ${type})`
    );

    await ensureConnection();

    await websocketPrintClient.printHtml({ content, type, printOptions });

    console.log("Print request sent successfully");

    return true;
  } catch (error) {
    console.error("Print Error:", error);
    alert(`Print Error: ${error.message}`);
    dispatchSetShowPrinterAlert(true);

    throw error;
  }
};

export const printHtmlDirectly = async (content, printOptions = {}) => {
  try {
    console.log("Printing direct HTML content via WebSocket Print Service");

    await ensureConnection();

    await websocketPrintClient.printHtmlDirectly(content, printOptions);

    console.log("Direct HTML print request sent successfully");

    return true;
  } catch (error) {
    console.error("Print Error:", error);
    alert(`Print Error: ${error.message}`);
    dispatchSetShowPrinterAlert(true);

    throw error;
  }
};

export const printShippingRouteHtml = async (content, printOptions = {}) => {
  try {
    console.log(
      "Printing shipping route HTML content via WebSocket Print Service"
    );

    await ensureConnection();

    printOptions.type = "shippingRoute";

    await websocketPrintClient.printShippingRouteHtml(content, printOptions);

    console.log("Shipping route HTML print request sent successfully");

    return true;
  } catch (error) {
    console.error("Print Error:", error);
    alert(`Print Error: ${error.message}`);
    dispatchSetShowPrinterAlert(true);

    throw error;
  }
};

export const printReactComponent = async ({
  component,
  type = "order",
  printOptions = {},
}) => {
  try {
    console.log("Printing React component via WebSocket Print Service");

    await ensureConnection();

    await websocketPrintClient.printReactComponent({
      component,
      type,
      printOptions,
    });

    console.log("Print request sent successfully");

    return true;
  } catch (error) {
    console.error("Print Error:", error);
    alert(`Print Error: ${error.message}`);
    dispatchSetShowPrinterAlert(true);

    throw error;
  }
};

export const printLabel = async (labelData, quantity = 1) => {
  try {
    console.log("Printing label via WebSocket Print Service");

    await ensureConnection();

    await websocketPrintClient.printLabel(labelData, quantity);

    console.log("Label print request sent successfully");

    return true;
  } catch (error) {
    console.error("Print Error:", error);
    alert(`Print Error: ${error.message}`);
    dispatchSetShowPrinterAlert(true);

    throw error;
  }
};

export const isPrintServiceReady = () => {
  return websocketPrintClient.isConnected;
};

export { websocketPrintClient };
